interface Dependent {
  key: string
  Name: string
  Relationship: string
  BirthDate?: string
  TermDate?: string
  CI?: string
  CIDate?: string
}

interface DependentsTileGridProps {
  dependents: Dependent[]
}

interface DependentTileProps {
  dependent: Dependent
}

export function DependentsTileGrid({dependents}: DependentsTileGridProps) {
  if (!dependents?.length) return null

  return (
    <div
      className='
        grid gap-4 w-full
        grid-cols-1
        sm:grid-cols-2
        lg:grid-cols-3
        xl:grid-cols-4
      '
    >
      {dependents.map((d) => (
        <DependentTile key={d.key} dependent={d} />
      ))}
    </div>
  )
}

function DependentTile({dependent}: DependentTileProps) {
  const {Name, Relationship, BirthDate, CI, CIDate, TermDate} = dependent

  return (
    <div className="rounded-lg p-4 flex flex-col gap-3 text-[16px] font-['Roboto'] shadow-sm" style={{backgroundColor: '#0074A6', color: 'white'}}>
      {/* Header */}
      <div>
        <p className='text-[16px] font-bold'>{Name}</p>
        <p className='text-[16px] font-normal'>{Relationship}</p>
      </div>

      {/* Core info */}
      {BirthDate && <TileRow label='Birth Date' value={BirthDate} whiteText />}

      {/* Optional info */}
      {(CI || CIDate || TermDate) && (
        <div className='pt-2 mt-1 border-t border-white/30 flex flex-col gap-1'>
          {CI && <TileRow label='CI' value={CI} whiteText />}
          {CIDate && <TileRow label='CI Date' value={CIDate} whiteText />}
          {TermDate && <TileRow label='Term Date' value={TermDate} whiteText />}
        </div>
      )}
    </div>
  )
}

function TileRow({label, value, whiteText}: {label: string; value: string; whiteText?: boolean}) {
  const labelClass = whiteText ? 'text-white font-normal' : 'text-blue-700 font-normal'
  const valueClass = whiteText ? 'text-white font-normal' : 'text-blue-900 font-normal'

  return (
    <div className="flex justify-between text-[16px] font-['Roboto']">
      <span className={labelClass}>{label}</span>
      <span className={valueClass}>{value}</span>
    </div>
  )
}
